var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table",
    _vm._l(_vm.block.value.content, function (row) {
      return _c(
        "tr",
        { key: row },
        _vm._l(_vm.getRow(row), function (cell, i) {
          return _c("td", { key: i }, [_vm._v(_vm._s(cell))])
        }),
        0
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }